import React from 'react';
export function App() {
  return <div className="min-h-screen flex items-center justify-center bg-gray-100" data-id="element-0">
      <div className="text-center p-8" data-id="element-1">
        <h1 className="text-3xl font-bold mb-4" data-id="element-2">Welcome</h1>
        <p data-id="element-3">This is a new project. Start building your app!</p>
      </div>
    </div>;
}